import { Button as AntdMobileButton } from "antd-mobile";
import { BaseButtonProps } from "./Button.types";
import "./Button.scss";

export const Button: React.FC<BaseButtonProps> = ({
  children,
  variant = "tertiary", //  primary | secondary | tertiary
  size = "xl",
  shape = "default",
  loading = false,
  block = false,
  className = "",
  disabled,
  onClick,
  ...props
}) => {
  const buttonClass = [
    "btn",
    `btn--${variant}`,
    disabled && "btn--disabled",
    `btn--${size}`,
    shape !== "default" && `btn--${shape}`,
    loading && "btn--loading",
    block && "btn--block",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const antdSize =
    size === "large" || size === "lg" || size === "xl" ? "large" : "middle";

  const antdShape =
    shape === "circle"
      ? "rectangular"
      : shape === "rounded"
        ? "rounded"
        : "rectangular";

  // 防止按钮获得焦点导致的自动滚动
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    // 立即失焦，防止焦点导致页面滚动
    setTimeout(() => {
      (e.currentTarget as HTMLButtonElement)?.blur();
    }, 0);
    onClick?.(e);
  };

  return (
    <AntdMobileButton
      className={buttonClass}
      disabled={disabled || loading}
      loading={loading}
      block={block}
      size={antdSize}
      shape={antdShape}
      onClick={handleClick}
      {...props}
    >
      {children}
    </AntdMobileButton>
  );
};

export default Button;
